module.exports = __webpack_public_path__ + "img/thumbnail-header-26.3cca0d8.png";